export default __webpack_public_path__ + "static/media/WIGO.576bf1d4.svg";